import ComingSoon from '@/components/ComingSoon';
import UnderConstructionSvg from '@/components/UnderConstructionSvg';

const PortalPrivateRoute = ({ children }: { children: React.ReactNode }) => {
  return <ComingSoon featureName="Under Construction" description="Self-service portal for end users is under development. Backend APIs for portal login, device enrollment, and approval workflows are not yet available." illustration={<UnderConstructionSvg />} />;
};

export default PortalPrivateRoute;
